jQuery(function($) {

  function initProductsSlider() {
    var $slider = $('.r6-products-slider > .slider');

    if ($slider.length) {
      // Destroy slick if already initialized
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }

      // Only initialize if there’s more than 1 slide
      if ($slider.children().length > 1) {
        $slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          speed: 600,
          fade: true,
          appendDots: $('.dots-wrapper'),
        });
      }
    }
  }

  // Run on page load
  $(window).on('load', function() {
    initProductsSlider();
  });

  // Run again on resize
  $(window).on('resize', function() {
    initProductsSlider();
  });

});
